import { useEffect, useState } from 'react';

import { Template } from '@client:common/Template';
import { Tool } from '@client:common/Tool';
import { ModelComparisonTable } from '@client:common/model-comparison-table';

import { Ranking } from '../../models/Ranking';

import './RankingTable.light.scss';
import './RankingTable.dark.scss';

interface Props {
  topRankings: Ranking[];
  allRankings: Ranking[];
  rowSpecifications: Array<{ path: string }>;
  template: Template;
  tools: { [toolName: string]: Tool };
}

export function RankingTable(props: Props) {
  const [selectedModels, setSelectedModels] = useState(
    props.topRankings.map((ranking) => ranking.model)
  );
  const [allModels, setAllModels] = useState([]);
  const [scoreData, setScoreData] = useState(null);

  useEffect(() => {
    setAllModels(props.allRankings.map((ranking) => ranking.model));
  }, [props.allRankings]);

  useEffect(() => {
    setSelectedModels(props.topRankings.map((ranking) => ranking.model));
  }, [props.topRankings]);

  useEffect(() => {
    if (selectedModels.length === 0) {
      setScoreData(null);
      return;
    }

    const scores = selectedModels.map(model => {
      const ranking = props.allRankings.find(r => r.model === model);
      return {
        modelId: model.acronym,
        score: `${ranking.score}/10`
      };
    });

    setScoreData({
      label: 'Score',
      scores
    });
  }, [selectedModels, props.allRankings]);

  return (
    <ModelComparisonTable
      className='ranking-table'
      models={allModels}
      selectedModels={selectedModels}
      rowSpecifications={props.rowSpecifications}
      template={props.template}
      tools={props.tools}
      scoreData={scoreData}
      onSelectedModelsChange={setSelectedModels}
    />
  );
}
